import { push } from 'connected-react-router';

export default (contactId = null, projetcId = null) =>
    (dispatch) =>
        dispatch(push(`/contacts/${contactId}/${projetcId ? projetcId : ''}`));
